/**
 * ציור אימפסטו — מריחות עבות עם הדגשת אור, צל וערבוב (מראה שמן / אקריליק).
 */

function hexToRgb(hex) {
  const n = String(hex || '').replace('#', '')
  if (n.length !== 6) return [120, 80, 200]
  return [parseInt(n.slice(0, 2), 16), parseInt(n.slice(2, 4), 16), parseInt(n.slice(4, 6), 16)]
}

function rgbToHex(r, g, b) {
  const c = (x) => Math.round(Math.max(0, Math.min(255, x))).toString(16).padStart(2, '0')
  return `#${c(r)}${c(g)}${c(b)}`
}

function mixRgb(a, b, t) {
  return [
    a[0] + (b[0] - a[0]) * t,
    a[1] + (b[1] - a[1]) * t,
    a[2] + (b[2] - a[2]) * t,
  ]
}

function hash2(x, y) {
  const s = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453
  return s - Math.floor(s)
}

/** פרמטרים לפי מדיה */
function getImpastoConfig(kind, intensity) {
  const t = Math.max(0.35, Math.min(1.15, intensity))
  if (kind === 'acrylic') {
    return {
      dabCount: Math.round(3 + t),
      stepFactor: 0.22,
      spread: 0.78 * t,
      alphaBody: 0.62,
      alphaEdge: 0.38,
      alphaHighlight: 0.42,
      edgeDarken: 0.28,
      highlightLift: 0.38,
      glossX: -0.12,
      glossY: -0.16,
      composite: 'source-over',
      softShadow: 0.35,
      ridgeSharp: 0.85,
    }
  }
  if (kind === 'impasto') {
    return {
      dabCount: Math.round(4 + t * 1.2),
      stepFactor: 0.18,
      spread: 1.05 * t,
      alphaBody: 0.48,
      alphaEdge: 0.32,
      alphaHighlight: 0.5,
      edgeDarken: 0.32,
      highlightLift: 0.45,
      glossX: -0.14,
      glossY: -0.2,
      composite: 'multiply',
      softShadow: 0.42,
      ridgeSharp: 0.65,
    }
  }
  // oil (default)
  return {
    dabCount: Math.round(4 + t),
    stepFactor: 0.2,
    spread: 0.95 * t,
    alphaBody: 0.5,
    alphaEdge: 0.28,
    alphaHighlight: 0.55,
    edgeDarken: 0.35,
    highlightLift: 0.42,
    glossX: -0.18,
    glossY: -0.22,
    composite: 'multiply',
    softShadow: 0.48,
    ridgeSharp: 0.55,
  }
}

function paintDab(ctx, cx, cy, rx, ry, rotation, color, alpha) {
  ctx.save()
  ctx.translate(cx, cy)
  ctx.rotate(rotation)
  ctx.globalAlpha = alpha
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.ellipse(0, 0, rx, ry, 0, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()
}

function strokePoints(prev, x, y, step) {
  const dx = x - prev.x
  const dy = y - prev.y
  const dist = Math.hypot(dx, dy)
  if (dist < 0.5) return [{ x, y, t: 1 }]
  const n = Math.max(1, Math.ceil(dist / step))
  const pts = []
  for (let i = 0; i <= n; i++) {
    const t = i / n
    pts.push({ x: prev.x + dx * t, y: prev.y + dy * t, t })
  }
  return pts
}

/**
 * מכה אימפסטו בודדת (נקודת מגע ראשונה).
 */
function paintImpastoCluster(ctx, x, y, baseRgb, cfg) {
  const baseSize = ctx._impastoBrushSize || 12
  for (let i = 0; i < cfg.dabCount; i++) {
    const h1 = hash2(x + i * 17.3, y + i * 9.1)
    const h2 = hash2(x + i * 3.7, y + i * 11.9)
    const angle = h1 * Math.PI * 2
    const dist = baseSize * cfg.spread * (0.15 + h2 * 0.35)
    const px = x + Math.cos(angle) * dist
    const py = y + Math.sin(angle) * dist
    paintImpastoAt(ctx, px, py, baseRgb, cfg, h1, angle)
  }
}

function paintImpastoAt(ctx, px, py, baseRgb, cfg, h1, angle) {
  const baseSize = ctx._impastoBrushSize || 12
  const rx = baseSize * (0.38 + h1 * 0.28) * cfg.spread
  const ry = rx * (0.72 + hash2(px, py + 1) * 0.35)
  const rot = angle + (hash2(px + 5, py) - 0.5) * 0.8

  const edgeRgb = mixRgb(baseRgb, [0, 0, 0], cfg.edgeDarken)
  const hiRgb = mixRgb(baseRgb, [255, 255, 255], cfg.highlightLift)
  const bodyHex = rgbToHex(...baseRgb)
  const edgeHex = rgbToHex(...edgeRgb)
  const hiHex = rgbToHex(...hiRgb)

  const hx = px + rx * cfg.glossX * 2.2
  const hy = py + ry * cfg.glossY * 2.2

  ctx.save()
  ctx.globalCompositeOperation = cfg.composite

  if (cfg.softShadow > 0) {
    paintDab(ctx, px + rx * 0.08, py + ry * 0.12, rx * 1.05, ry * 1.05, rot, edgeHex, cfg.alphaEdge * cfg.softShadow * 0.5)
  }

  paintDab(ctx, px, py, rx * 1.08, ry * 1.08, rot, edgeHex, cfg.alphaEdge)
  paintDab(ctx, px, py, rx * cfg.ridgeSharp, ry * cfg.ridgeSharp, rot, bodyHex, cfg.alphaBody)
  paintDab(ctx, hx, hy, rx * 0.42, ry * 0.38, rot + 0.2, hiHex, cfg.alphaHighlight)

  ctx.restore()
}

/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} x
 * @param {number} y
 * @param {{ x: number, y: number } | null} prev
 * @param {{ color: string, brushSize: number, kind?: 'oil' | 'acrylic' | 'impasto', intensity?: number }} opts
 */
export function drawImpastoStroke(ctx, x, y, prev, opts) {
  const { color, brushSize, kind = 'oil', intensity = 1 } = opts
  const baseRgb = hexToRgb(color)
  const cfg = getImpastoConfig(kind, intensity)
  ctx._impastoBrushSize = Math.max(4, brushSize)

  if (!prev) {
    paintImpastoCluster(ctx, x, y, baseRgb, cfg)
    return
  }

  const step = Math.max(2, brushSize * cfg.stepFactor)
  const points = strokePoints(prev, x, y, step)

  for (const pt of points) {
    const h1 = hash2(pt.x * 0.31, pt.y * 0.17 + pt.t)
    const h2 = hash2(pt.x * 0.09, pt.y * 0.23)
    const wobble = brushSize * cfg.spread * (0.12 + h2 * 0.22)
    const px = pt.x + (h1 - 0.5) * wobble
    const py = pt.y + (hash2(pt.y, pt.x) - 0.5) * wobble
    const angle = Math.atan2(y - prev.y, x - prev.x) + (h1 - 0.5) * 0.65
    paintImpastoAt(ctx, px, py, baseRgb, cfg, h1, angle)
  }
}
